(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["store-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
    const chat = document.getElementById('store-chat');
    if (!chat) return;
    const toggle = chat.querySelector('summary');
    const close = () => { chat.open = false; toggle.focus(); };
    chat.querySelector('.store-chat__close').addEventListener('click', close);
    chat.addEventListener('keydown', event => { if (event.key === 'Escape' && chat.open) close(); });
    document.addEventListener('click', event => { if (chat.open && !chat.contains(event.target)) chat.open = false; });
  })();
  } catch(e) { console.error(e); }
})();

})();
